import React from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Paper,
  Typography,
} from "@mui/material";

const steps = [
  {
    label: "Phase1",
    description: "仲間を知る 4/4-4/14",
    content:
      "●Chatで会話してください。\n●オンライン(zoomなど)で繋がり自己紹介などお互いのことを知ってください。",
  },
  {
    label: "Phase2",
    description: "DDPについて深める 4/15-5/10",
    content:"● DDP作成のポイントを話し合い、各自のDDPを見直しましょう。\n● グループ内でお互いのDDPを深掘りし、確\定させましょう。\n● ゆめナビのカード（祈り）にコメントし、提出者へアドバイスを送りましょう。",
  },
  {
    label: "Phase3",
    description: "DDP添削をzoomや対面で行う 5/11-6/5",
    content:"●ゆめナビのDDPの添削を通じ、多くの仲間の夢を支援し仲間になりましょう。それを通じて8名のグループメンバーの関係性を深めましょう。\n●グループでzoomやリアルでの添削会を開催してみましょう。\n●今いるメンバーで実際に会いましょう。",
  },


  {
    label: "Phase4",
    description: "仲間のDDPを応援する 6/6-6/19",
    content:"●仲間が夢を叶えている姿を想像し、仲間へ手紙を書きましょう。\n●仲間の夢を応援し合いましょう。",
  },
  {
    label: "Phase5",
    description: "DDPを叶える 6/20-7/5",
    content:"●DDPを叶えるための行動をしましょう。\n●行動したことを仲間にシェアしましょう。",
  },

];

const Schedule2025H = () => {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  return (
    <div
      style={{
        width: "100%",
        marginTop: "16px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ maxWidth: "600px" }}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel onClick={handleStep(index)}>
                {step.label} - {step.description}
              </StepLabel>
              <StepContent>
                {step.content.split("\n").map((line, idx) => (
                  <Typography key={idx}>{line}</Typography>
                ))}
              </StepContent>
            </Step>
          ))}
        </Stepper>
        {/* {activeStep === steps.length && (
            <Paper square elevation={0} style={{ padding: '16px' }}>
              <Typography>All steps completed - you&apos;re finished</Typography>
            </Paper>
          )} */}
      </div>
    </div>
  );
};

export default Schedule2025H;
